/**
 * DADDL contact form — dial-code concat, Intl country names, timestamp.
 * Dropdown chrome is snippets/daddl-select.liquid + assets/daddl-select.js.
 */
(function () {
  'use strict';

  const form = document.getElementById('ContactForm');
  if (!form) return;

  const phoneInput = form.querySelector('#ContactForm-phone');
  const phoneFullInput = form.querySelector('#ContactForm-phone-full');
  const timestampInput = form.querySelector('#ContactForm-timestamp');
  const dialSelect = form.querySelector('#ContactForm-dial-select');
  const subjectSelect = form.querySelector('#ContactForm-subject-select');
  const countryCodeInput = dialSelect
    ? dialSelect.querySelector('[data-daddl-select-input]')
    : null;

  function localizeCountryNames() {
    if (!dialSelect) return;
    const lang = (document.documentElement.lang || 'en').split('-')[0];
    if (lang === 'en' || typeof Intl === 'undefined' || !Intl.DisplayNames) return;
    let regionNames;
    try {
      regionNames = new Intl.DisplayNames([document.documentElement.lang || lang], { type: 'region' });
    } catch (err) {
      return;
    }
    dialSelect.querySelectorAll('.daddl-select__option').forEach((option) => {
      const iso = (option.getAttribute('data-country') || '').toUpperCase();
      const dial = option.getAttribute('data-value') || '';
      if (!iso) return;
      let localized;
      try {
        localized = regionNames.of(iso);
      } catch (err) {
        return;
      }
      if (!localized) return;
      const flag = option.querySelector('.fi');
      const label = option.querySelector('[data-daddl-select-option-label]');
      if (label) {
        label.textContent = `${dial} ${localized}`;
      } else {
        option.textContent = '';
        if (flag) option.appendChild(flag);
        option.appendChild(document.createTextNode(` ${dial} ${localized}`));
      }
    });
  }

  function updateFullPhoneNumber() {
    if (!phoneInput || !phoneFullInput || !countryCodeInput) return;
    const phone = phoneInput.value.trim();
    phoneFullInput.value = phone ? countryCodeInput.value + phone.replace(/[\s\-]/g, '') : '';
  }

  /* Choose the option element, not the dial value: +1 is shared (US, Canada, …),
     and setValue('+1') would land on whichever comes first. */
  function applyDefaultDial() {
    if (!dialSelect || typeof dialSelect.choose !== 'function') return;
    const iso = (dialSelect.getAttribute('data-default-country') || 'ae').toLowerCase();
    const options = Array.from(dialSelect.querySelectorAll('.daddl-select__option'));
    const match =
      options.find((option) => (option.getAttribute('data-country') || '').toLowerCase() === iso) ||
      options.find((option) => (option.getAttribute('data-country') || '').toLowerCase() === 'ae') ||
      options[0];
    if (match) dialSelect.choose(match, { silent: true });
  }

  localizeCountryNames();
  applyDefaultDial();

  if (dialSelect) {
    dialSelect.addEventListener('daddl-select:change', updateFullPhoneNumber);
  }

  if (phoneInput) {
    phoneInput.addEventListener('input', (event) => {
      let value = event.target.value;
      if (value.startsWith('+') && dialSelect) {
        const codes = Array.from(dialSelect.querySelectorAll('.daddl-select__option')).map((option) =>
          option.getAttribute('data-value')
        );
        codes.sort((a, b) => b.length - a.length);
        const matched = codes.find((code) => value.startsWith(code));
        if (matched) {
          dialSelect.setValue(matched);
          value = value.substring(matched.length);
        }
      }
      value = value.replace(/[^\d\s\-]/g, '').replace(/^0+/, '');
      event.target.value = value;
      updateFullPhoneNumber();
    });
    phoneInput.addEventListener('keydown', (event) => {
      if (event.target.value.length === 0 && event.key === '0') event.preventDefault();
    });
  }

  if (form && timestampInput) {
    form.addEventListener('submit', () => {
      timestampInput.value = new Date().toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short'
      });
      updateFullPhoneNumber();
    });
  }

  if (form.querySelector('.daddl-contact__success')) {
    form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], textarea').forEach((el) => {
      if (el.type !== 'hidden') el.value = '';
    });
    if (timestampInput) timestampInput.value = '';
    if (phoneFullInput) phoneFullInput.value = '';
    applyDefaultDial();
    if (subjectSelect && typeof subjectSelect.setValue === 'function') subjectSelect.setValue('');
  }

  updateFullPhoneNumber();
})();
